module.exports = __webpack_public_path__ + "static/media/pokerPhone1.58a7f7fa.svg";